<template>
    <b-img @click="$emit('click')" class="client-logo" :src="logoUrl" v-if="logoUrl"></b-img>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Client-Logo',
  computed: {
    ...mapGetters(['userClient']),
    logoUrl() {
      return this.userClient.logo;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.client-logo {
    max-height: 50px;
}
</style>
